export const campaignsSelector = {
  campaigns: (state) => state.campaignsInfo.campaigns,
  filteredCampaigns: (state) => state.campaignsInfo.filteredCampaigns,
  filterValue: (state) => state.campaignsInfo.filterValue,
  all_object: (state) => state.campaignsInfo
}

